<template>
    <div class="dashboard">
        <div class="d-flex">
            <div class="col-sidebar">
                <div class="sidebar-admin">
                    <div class="menu scrollbar">
                        <div class="accordion accordion-menu" id="accordionMenu">
                            <div class="accordion-item" v-for="(item, index) in dashboards" :key="index">
                                <div class="accordion-header" :id="`heading${index}`">
                                    <div v-if="item.subMenu != null" class="item-menu border-none py-3 ps-3 collapsed position-relative pe-40" data-bs-toggle="collapse" :data-bs-target="`#collapse${index}`" aria-expanded="false" :aria-controls="`collapse${index}`">
                                        <i class="icon ion-md-folder me-1"></i>
                                        {{ item.title }}
                                        <i class="icon ion-ios-arrow-down position-absolute"></i>
                                    </div>
                                    <div class="item-menu p-3 m-2" v-else @click="url(item.name)">
                                        <i :class="{
                                                'icon me-1': true,
                                                'ion-md-home': item.name == 'layout',
                                                'ion-md-folder': item.name != 'layout',
                                            }"></i>
                                        {{ item.title }}
                                    </div>
                                </div>
                                <div :id="`collapse${index}`" class="accordion-collapse collapse" :aria-labelledby="`heading${index}`" data-bs-parent="#accordionMenu">
                                    <div class="accordion-body">
                                        <div class="list-sub-menu">
                                            <div class="item-sub py-2 pe-3 m-2" v-for="(data, key) in item.subMenu" :key="key" @click="url(data.name)">
                                                {{ data.title }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-main">
                <div class="header-admin">
                    <div class="d-flex bd-highlight mb-3 align-items-center py-2">
                        <div class="breadcrumb-header ps-3">
                            <breadcrumb/>
                        </div>
                        <div class="ms-auto">
                            <div class="me-2 account position-relative">
                                <div class="d-flex align-items-center info-admin">
                                    <div class="info">
                                        {{ user.name }}
                                    </div>
                                    <div class="avatar ms-2">
                                        <img alt="avatar" :src="$urlImage('/images/avatar.png')" />
                                    </div>
                                </div>
                                <div class="detail-admin bg-white position-absolute py-3 px-2">
                                    <div class="detail p-2 mb-2" @click="directInfo()">
                                        <i class="icon ion-md-list-box me-2"></i>Thông tin tài khoản
                                    </div>
                                    <div class="logout p-2" @click="logout()">
                                        <i class="icon ion-ios-log-out me-2"></i>Đăng xuất
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="body-admin scrollbar">
                    <div class="body-index" v-if="this.$route.name == 'layout'">
                        <div class="height">
                            <p class="text-center text-index">Trang quản trị hiện vật</p>
                        </div>
                    </div>
                    <div v-else>
                        <router-view/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {dashboard} from '@/config/dashboard.js';
export default {
    components: {
        breadcrumb: () => import('./breadcrumb.jsx'),
    },
    data(){
        return {
            dashboards: [],
            user: {},
            token: localStorage.getItem('token'),
        }
    },
    computed: {
        routerName(){
            return this.$route.name;
        },
    },
    watch: {
        routerName(val){
            this.setActiveDashboard(val);
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    created(){
        this.dashboards = dashboard;
    },
    methods: {
        url(name) {
            this.$router.push({
                name: name,
            })
        },
        directInfo() {
            this.$router.push({
                name: 'info',
            })
        },
        setActiveDashboard(nameRouter){
            let item, itemSub;
            for (const key in this.dashboards) {
                item = this.dashboards[key];
                if(item.path && !item.subMenu && item.name == nameRouter){
                    if(!item.show){
                        if(item.active_same !== null){
                            this.$store.commit('setActiveDashboard', item.active_same.toString());
                        }
                    }else{
                        this.$store.commit('setActiveDashboard', key.toString());
                    }
                    this.setTitle(item.title);
                    this.title = item.title
                    this.$store.commit('setBreadcrumbs', item.breadcrumb);
                }else if(item.subMenu){
                    for (const k in item.subMenu) {
                        itemSub = item.subMenu[k];
                        if(itemSub.path && itemSub.name == nameRouter){
                            if(!itemSub.show){
                                this.$store.commit('setActiveDashboard', key + '-' + itemSub.active_same);
                            }else{
                                this.$store.commit('setActiveDashboard', key + '-' + k);
                            }
                            this.$store.commit('setBreadcrumbs', itemSub.breadcrumb);
                            this.setTitle(itemSub.title);
                            this.title = itemSub.title;
                        }
                    }
                }
            }
        },
        setTitle(title){
            document.querySelector('title').setAttribute('content', title);
            document.querySelector('title').innerText = title;
        },
        logout() {
            apiPost('/logout',).then(res => {
                Vue.$toast.info(res.message, {
                    timeout: 3000,
                });
                localStorage.removeItem('token');
                this.$router.push({
                    name: 'login',
                });
            }).catch(err => {
                console.log(err);
            })
        }
    },
    mounted() {
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;

        apiGet('/user').then(res => {
            this.user = res;
        }).catch(err => {
            localStorage.removeItem('token');
            this.$Notice.error({
                title: 'Lỗi hệ thống',
                desc: 'Vui lòng đăng nhập hoặc thử lại sau',
            });
            this.$router.push({
                name: 'login',
            });
        });
    },
}
</script>

<style lang="scss">
.dashboard {
    background-color: #f8f9fd;
    height: 100vh;
    overflow: hidden;
    .d-flex {
        .col-sidebar {
            width: 300px;
        }
        .col-main {
            width: calc(100% - 300px);
        }
    }
    .body-admin {
        box-shadow: 0 4px 15px 0 rgba(30,30,30,.12);
        margin-top: 16px;
        margin-left: 16px;
        background: #fff;
    }
    .sidebar-admin {
        min-height: 100vh;
        background-color: #fff;
        box-shadow: 0 4px 15px 0 rgba(30,30,30,.12);
        border-right: 1px solid rgba(0,0,0,.05);
        .logo {
            padding-bottom: 28px;
        }
        .menu {
            height: calc(100vh - 83px);
            overflow: auto;
            padding-top: 83px;
            .item-menu {
                color: #000;
                font-weight: 600;
                border-radius: 8px;
                margin: 8px !important;
                text-align: unset !important;
                cursor: pointer;
                i::before {
                    font-size: 20px;
                    vertical-align: -1px;
                }
                &:hover {
                    color : #fff;
                    background-color: #0d6efd;
                }
                .ion-ios-arrow-down {
                    right: 16px;
                }
            }
            .pe-40 {
                padding-right: 40px;
            }
        }
    }
    .header-admin {
        background-color: #fff;
        box-shadow: 20px 0 15px 0 rgba(30,30,30,.12);
        .account {
            &:hover {
                .detail-admin {
                    display: block !important;
                }
            }
            .info-admin {
                padding: 8px 14px;
                &:hover {
                    background-color: rgba(204, 235, 255, 0.5);
                    cursor: pointer;
                    border-radius: 8px;
                }
                .info {
                    font-weight: 600;
                    font-size: 14px;
                }
                .avatar {
                    img {
                        width: 35px;
                        height: 35px;
                    }
                }
            }
            .detail-admin {
                display: none;
                box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
                right: 0;
                width: 250px;
                border-radius: 8px;
                font-size: 14px;
                .detail {
                    color: #000;
                    border-radius: 8px;
                    cursor: pointer;
                    &:hover {
                        background: rgba(13, 110, 253, 1);
                        color: #fff;
                    }
                }
                .logout {
                    border-radius: 8px;
                    cursor: pointer;
                    &:hover {
                        background: rgba(13, 110, 253, 1);
                        color: #fff;
                    }
                }
                i {
                    &::before {
                        font-size: 18px;
                    }
                }
            }
        }
        .breadcrumb-header {
            font-size: 18px;
        }
    }
    .accordion-menu {
        .accordion-item {
            border: none !important;
            .accordion-body {
                padding: 0 !important;
            }
            .list-sub-menu {
                .item-sub {
                    padding-left: 40px;
                    cursor: pointer;
                    &:hover {
                        color: #0d6efd;
                    }
                }
            }
        }
    }
    .body-index {
        .height {
            height: calc(100vh - 83px);
            .text-index {
                font-size: 32px;
                padding: 100px 0;
            }
        }
    }
    #title-artifact {
        .ql-editor {
            min-height: unset !important;
        }
    }
}
</style>
